import React from 'react'
import styled from 'styled-components'
import { BORDER_RADIUS_MEDIUM } from '../../../../constants'
import { CreationToolSourceFile } from '../../../../types'
import CreationToolWatermarkPosition from '../../../../types/watermark'
import ArtboardComponent from '../../../artboard'
import Watermark from '../../../artboard/layer/watermark'
import VideoPlayerComponent from '../../../video-player'

const Preview = styled.div`
    position: relative;
    text-align: center;
`

const VideoPlayer = styled(VideoPlayerComponent)`
    border-radius: ${BORDER_RADIUS_MEDIUM}px;
    display: inline-block;
    width: auto;
`

const Artboard = styled(ArtboardComponent)`
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`

type Props = {
    className?: string
    source: CreationToolSourceFile
    width: number
    watermark?: string
    watermarkPosition?: CreationToolWatermarkPosition
    defaultWatermarkWidth?: number
    onWatermarkResize?: (width: number) => void
}

const CreationCapturePreview = ({
    className,
    source,
    width,
    watermark,
    watermarkPosition = CreationToolWatermarkPosition.BottomRight,
    defaultWatermarkWidth,
    onWatermarkResize,
}: Props) => {
    const canvasScale = source.width / width
    const height = width / (source.width / source.height)

    return (
        <Preview className={className}>
            <VideoPlayer source={source} width={width}>
                {watermark && (
                    <Artboard
                        {...{
                            width,
                            height,
                            canvasScale,
                        }}
                    >
                        <Watermark
                            {...{
                                source: watermark,
                                position: watermarkPosition,
                                width: (defaultWatermarkWidth || Math.round(source.width * 0.2)) / canvasScale,
                                resizeable: true,
                                onUpdate: onWatermarkResize,
                            }}
                        />
                    </Artboard>
                )}
            </VideoPlayer>
        </Preview>
    )
}

export default CreationCapturePreview
